import { render, staticRenderFns } from "./new-apply.vue?vue&type=template&id=06973bc2&"
import script from "./new-apply.vue?vue&type=script&lang=js&"
export * from "./new-apply.vue?vue&type=script&lang=js&"
import style0 from "./new-apply.vue?vue&type=style&index=0&lang=less&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports